import { useGetSchoolCalendarsQuery } from 'Services/ControlDataManagement/Features/SchoolCalendar/schoolCalendarApi'
import type { FetchSchoolCalendarListParams } from 'Services/ControlDataManagement/Features/SchoolCalendar/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_SCHOOL_CALENDAR_PARAMETER_KEY = 'selectedSchoolCalendar'

function useSchoolCalendarsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchSchoolCalendarListParams>({
    sort_by: searchParams.get('sort_by') ?? 'id',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    codespace_id: searchParams.get('codespace_id') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const {
    data: { resources: schoolCalendars } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching
  } = useGetSchoolCalendarsQuery(params)

  const selectedSchoolCalendarQueryParam =
    searchParams.get(SELECTED_SCHOOL_CALENDAR_PARAMETER_KEY) ?? undefined
  const [selectedSchoolCalendarId, setSelectedSchoolCalendarId] = useState(
    selectedSchoolCalendarQueryParam
  )

  const setQueryParams = () => {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    selectedSchoolCalendarId &&
      searchParams.set(SELECTED_SCHOOL_CALENDAR_PARAMETER_KEY, selectedSchoolCalendarId)
    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedSchoolCalendarId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_SCHOOL_CALENDAR_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedSchoolCalendarId])

  return {
    schoolCalendars,
    isFetching,
    totalResults,
    params,
    setParams,
    selectedSchoolCalendarId,
    setSelectedSchoolCalendarId
  }
}

export default useSchoolCalendarsWithParams
